/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const WalletTransactionSourceType = {
  Transfer: "transfer",
  Dispute: "dispute",
  IssuingCardTransaction: "issuing-card-transaction",
  IssuingAuthorization: "issuing-authorization",
  Sweep: "sweep",
  Adjustment: "adjustment",
  Fee: "fee",
  Residual: "residual",
} as const;
export type WalletTransactionSourceType = ClosedEnum<
  typeof WalletTransactionSourceType
>;

/** @internal */
export const WalletTransactionSourceType$inboundSchema: z.ZodNativeEnum<
  typeof WalletTransactionSourceType
> = z.nativeEnum(WalletTransactionSourceType);
/** @internal */
export const WalletTransactionSourceType$outboundSchema: z.ZodNativeEnum<
  typeof WalletTransactionSourceType
> = WalletTransactionSourceType$inboundSchema;
